import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;
	const documentTypeArray = ['EGD022', 'EGD029', 'EGD033'];

	return !policyHolderId && !!documentType && documentCategory ===  "EGD04"
	            && !documentTypeArray.includes(documentType) ? { checkDocCategoryIsCorruptionPreventionAndDocTypeAllowedFlag: true } : null;
};
